import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AllClass from './Containers/AllClass/AllClass';

class App extends Component {
 
  render() {
    return (
      <div className="App">
      <AllClass/>
      </div>
    );
  }
}

export default App;
